import React from 'react';
import { NavLink } from 'react-router-dom';
import { FiHome, FiBook, FiCheckSquare, FiGrid, FiMoreHorizontal } from 'react-icons/fi';
import './TeacherMobileNavigation.css';

const mobileNavItems = [
  { to: '/teacher/dashboard', icon: FiHome, label: 'Dashboard' },
  { to: '/teacher/classes', icon: FiBook, label: 'Classes' },
  { to: '/teacher/grading', icon: FiCheckSquare, label: 'Grading' },
  { to: '/teacher/gradebook', icon: FiGrid, label: 'Gradebook' },
  { to: '/teacher/assignments', icon: FiMoreHorizontal, label: 'More' },
];

function TeacherMobileNavigation() {
  return (
    <nav className="teacher-mobile-nav" aria-label="Teacher Portal mobile navigation">
      {mobileNavItems.map(item => (
        <NavLink
          key={item.to}
          to={item.to}
          className={({ isActive }) =>
            `teacher-mobile-nav__item ${isActive ? 'teacher-mobile-nav__item--active' : ''}`
          }
        >
          <item.icon className="teacher-mobile-nav__icon" size={20} />
          <span className="teacher-mobile-nav__label">{item.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}

export default TeacherMobileNavigation;
